<template>
  <vxe-colgroup
    :title="title"
    :field="columnOption.prop"
    :fixed="fixed"
    :align="columnOption.align"
  >
    <!-- 父级表头自定义 -->
    <template v-slot:header="{ column }">
      <slot v-bind="column" :name="`${columnOption.prop}_header`">
        <span v-if="isRequired(column.property)" style="color: red">*</span>
        <span>{{ column.title }}</span>
      </slot>
    </template>
    
    <!-- 遍历子列 -->
    <template v-for="(item, index) in columnOption.children">
      <!-- 子列没有嵌套 children 时，渲染 vxe-column -->
      <vxe-column
        v-if="!item.children"
        :key="`${item.prop}${index}`"
        v-bind="item"
        :title="$t(item.label)"
        :field="item.prop"
        :show-overflow="showOverflowTooltip || (item.isNotAutoWrap == true ? true : false)"
        :fixed="item.fixed === true ? 'left' : item.fixed"
        :sortable="sortable || item.sortable"
        :min-width="item.minWidth"
        :tree-node="item.isTree && index == 0 && 0 == item.colIndex"
      >
        <!-- 子列表头自定义 -->
        <template v-slot:header="{ column }">
          <slot v-bind="column" :name="`${item.prop}_header`">
            <span v-if="isRequired(column.property)" style="color: red">*</span>
            <span>{{ column.title }}</span>
            <i v-if="isEditable(column.property)" class="el-icon-edit" style="margin-left: 4px;"></i>
          </slot>
        </template>
        <!-- 子列内容 -->
        <template v-slot="slotProps">
          <slot v-bind="slotProps" :name="item.prop">{{
            columnText(slotProps.$index, slotProps.row, item, slotProps)
          }}</slot>
        </template>
      </vxe-column>
      
      <!-- 子列有嵌套 children 时，递归渲染 vxe-colgroup -->
      <x-dynamic-column
        v-else
        :columnOption="item"
        :columnText="columnText"
        :showOverflowTooltip="showOverflowTooltip"
        :isRequired="isRequired"
        :isEditable="isEditable"
        :title="$t(item.label)"
        :key="index"
        :fixed="item.fixed"
        :sortable="sortable"
        :allProps="item.props"
        :colIndex="index"
      >
        <!-- 透传内容插槽 -->
        <template v-for="myProp in item.props || []" v-slot:[myProp]="scope">
          <slot v-bind="scope" :name="myProp"></slot>
        </template>
        <!-- 透传表头插槽 -->
        <template v-for="myProp in item.props || []" v-slot:[`${myProp}_header`]="{ column }">
          <slot v-bind="column" :name="`${myProp}_header`"></slot>
        </template>
      </x-dynamic-column>
    </template>
  </vxe-colgroup>
</template>

<script>
export default {
  name: "x-dynamic-column",
  props: {
    showOverflowTooltip: {
      default: false
    },
    columnOption: {
      type: Object,
      required: true,
    },
    columnText: Function,
    isRequired: Function,
    isEditable: Function,
    fixed: String,
    sortable: Boolean,
    allProps: {
      type: Array,
      default: function () {
        return [];
      },
    },
    title: String,
    colIndex: Number,
  },
};
</script>
